import './Infohub.css';

function Infohub() {
  return (
    <div className="infohub-container">
      <div className="infohub-header-bar">
        <h2>Welcome to Your Class</h2>
      </div>
      <p className="infohub-text">
        This space is designed to support your learning journey, one slide at a time. Use the
        <strong> Prev</strong> and <strong>Next</strong> buttons below to navigate through the
        lesson.
      </p>
      <p className="infohub-text">
        As you move through the material, your personal <strong>Professor</strong> will provide
        real-time feedback and guidance, helping you understand, reflect, and retain what you learn.
      </p>
      <p className="infohub-text">
        While you study, we are quietly loading your full lesson in the background to keep your
        experience smooth and uninterrupted. You are in good hands. Let us begin.
      </p>
    </div>
  );
}

export default Infohub;
